import { useQuery } from '@tanstack/react-query';
import { ProviderCommissionType } from '@prisma/client';
import { Appointment } from '../../interfaces';
import { getAppointmentDepositCheckoutSession } from '../../services/appointments';

function useDepositCheckoutSession({
  appointment,
  status,
  depositPrice,
  isTerminal,
  providerCommissionType,
  enabled = true,
}: {
  appointment: Appointment | null | undefined;
  status: 'schedule' | 'reschedule';
  depositPrice: number;
  isTerminal?: boolean;
  providerCommissionType?: ProviderCommissionType | '';
  enabled?: boolean;
}) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      'depositCheckoutSession',
      status,
      appointment?.appointmentId,
      appointment?.businessId,
      depositPrice,
      isTerminal,
      providerCommissionType,
    ],
    queryFn: async () => {
      if (!appointment?.appointmentId) return null;
      const result = await getAppointmentDepositCheckoutSession({
        appointmentId: appointment.appointmentId,
        status,
        depositPrice,
        isPriceOnly: true,
        isTerminal,
        providerCommissionType: providerCommissionType || undefined,
      });
      return result;
    },
    enabled: !!appointment?.appointmentId && enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useDepositCheckoutSession;
